import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import useShowroomSearchInput from 'hooks/useShowroomSearchInput';
import CityStateSuggestionsDropdown from 'hooks/useCityStatePlacesAutocomplete/CityStateSuggestionsDropdown';
import { BANNER_IMAGE_URL } from './helpers';
const StoreLocatorSearch = t0 => {
  const $ = _c(37);
  const {
    zipcode,
    onZipcodeChange,
    onSearch,
    onSearchByPlace,
    onViewAll
  } = t0;
  const [error, setError] = useState("");
  const inputRef = useRef(null);
  let t1;
  if ($[0] !== onSearch || $[1] !== onSearchByPlace || $[2] !== onZipcodeChange) {
    t1 = {
      inputRef,
      onValueChange: onZipcodeChange,
      onSearchByZipcode: onSearch,
      onSearchByPlace
    };
    $[0] = onSearch;
    $[1] = onSearchByPlace;
    $[2] = onZipcodeChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    notifyValueChanged,
    validateValue,
    submitValue,
    suggestionsDropdownProps
  } = useShowroomSearchInput(t1);
  let t2;
  if ($[4] !== error || $[5] !== notifyValueChanged || $[6] !== onZipcodeChange) {
    t2 = event => {
      const {
        value
      } = event.target;
      onZipcodeChange(value);
      notifyValueChanged(value);
      if (error) {
        setError("");
      }
    };
    $[4] = error;
    $[5] = notifyValueChanged;
    $[6] = onZipcodeChange;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleZipChange = t2;
  let t3;
  if ($[8] !== onViewAll || $[9] !== submitValue || $[10] !== validateValue || $[11] !== zipcode) {
    t3 = event_0 => {
      event_0.preventDefault();
      const trimmed = zipcode.trim();
      if (!trimmed) {
        setError("");
        onViewAll();
        return;
      }
      const validationMessage = validateValue(trimmed);
      if (validationMessage) {
        setError(validationMessage);
        return;
      }
      setError("");
      submitValue(trimmed);
    };
    $[8] = onViewAll;
    $[9] = submitValue;
    $[10] = validateValue;
    $[11] = zipcode;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const handleSubmit = t3;
  let t4;
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      backgroundImage: `url(${BANNER_IMAGE_URL})`
    };
    t5 = <div className="absolute inset-0 bg-black/40" />;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  const t6 = error ? "true" : "false";
  const t7 = error ? "store-locator-zipcode-error" : undefined;
  let t8;
  if ($[15] !== handleZipChange || $[16] !== t6 || $[17] !== t7 || $[18] !== zipcode) {
    t8 = <input id="store-locator-zipcode" name="zipcode" type="text" placeholder="Zip Code or City, State" aria-label="Zip code or city and state" aria-invalid={t6} aria-describedby={t7} value={zipcode} onChange={handleZipChange} autoComplete="off" ref={inputRef} className="flex-1 min-w-0 px-3 py-2 bg-white text-base text-gray-dark placeholder-gray-light3 outline-none focus:ring-2 focus:ring-brand" />;
    $[15] = handleZipChange;
    $[16] = t6;
    $[17] = t7;
    $[18] = zipcode;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <button type="submit" data-xc="StoreLocatorSearchButton" className="px-6 bg-brand text-white text-base whitespace-nowrap hover:bg-gray-dark transition-colors">Find Showroom</button>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8) {
    t10 = <div className="flex items-stretch min-w-0">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== error) {
    t11 = error && <div id="store-locator-zipcode-error" role="alert" className="mt-1 text-sm text-white bg-red/80 px-2 py-1 rounded-sm">{error}</div>;
    $[23] = error;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onViewAll) {
    t12 = <div className="mt-2"><button type="button" data-xc="StoreLocatorViewAllButton" onClick={onViewAll} className="text-sm text-white underline hover:text-gray-light6">View All</button></div>;
    $[25] = onViewAll;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== handleSubmit || $[28] !== t10 || $[29] !== t11 || $[30] !== t12) {
    t13 = <div className="relative z-10 flex flex-col items-center justify-center h-full px-4"><div className="w-full max-w-2xl flex flex-col"><form onSubmit={handleSubmit} className="flex flex-1 flex-col min-w-0">{t10}{t11}{t12}</form></div></div>;
    $[27] = handleSubmit;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== suggestionsDropdownProps) {
    t14 = suggestionsDropdownProps && <CityStateSuggestionsDropdown {...suggestionsDropdownProps} />;
    $[32] = suggestionsDropdownProps;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <div className="relative w-full h-56 bg-center bg-cover" style={t4}>{t5}{t13}{t14}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
StoreLocatorSearch.propTypes = {
  zipcode: PropTypes.string.isRequired,
  onZipcodeChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSearchByPlace: PropTypes.func.isRequired,
  onViewAll: PropTypes.func.isRequired
};
export default StoreLocatorSearch;